const amplifyConfig = {
  cognito: {
    REGION: "us-west-2",
    USER_POOL_ID: "us-west-2_oO6R3Vs4K",
    APP_CLIENT_ID: "7l72u3cicom6rbps3h1n4b6rsr",
  },
};

export default amplifyConfig;
